import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Typography, Button,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useSessionExpiry, clearSessionExpiry } from '../utils/useSessionExpiry';
import { useSignOut } from 'react-auth-kit';

const SessionExpiryBanner = () => {
    const { expiryState, minutesRemaining, renewSession } = useSessionExpiry();
    const navigate = useNavigate();
    const signOut = useSignOut();

    if (expiryState === 'signout') {
        signOut();
        clearSessionExpiry();
        localStorage.removeItem('userName');
        localStorage.removeItem('who');
        navigate('/signin', { replace: true });
        return null;
    }

    if (expiryState === 'ok') return null;

    const handleRenew = async () => {
        try { await renewSession(); } catch { /* modal stays open */ }
    };

    const handleSignOut = () => {
        signOut();
        clearSessionExpiry();
        localStorage.removeItem('userName');
        localStorage.removeItem('who');
        navigate('/signin', { replace: true });
    };

    const isExpired = expiryState === 'expired';
    const hours = Math.floor(minutesRemaining / 60);
    const mins = minutesRemaining % 60;
    const timeLabel = hours > 0 ? `${hours}h ${mins}m` : `${mins} minute${mins !== 1 ? 's' : ''}`;

    return (
        <Dialog open disableEscapeKeyDown PaperProps={{ sx: { maxWidth: 420 } }}>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: isExpired ? 'error.main' : 'warning.main' }}>
                <ErrorOutlineIcon />
                {isExpired ? 'Login Session Expired' : 'Login Session Expiring Soon'}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    {isExpired
                        ? 'Your login session has expired. Click "Renew Session" to continue where you left off.'
                        : `Your login session expires in ${timeLabel}. Click "Renew Session" to stay signed in.`
                    }
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSignOut} color="inherit">
                    Sign Out
                </Button>
                <Button onClick={handleRenew} variant="contained">
                    Renew Session
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiryBanner;
